import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"

import api from "apis"

export default function fetchArticles(WrappedComponent) {
  const FetchArticles = ({ articleData }) => {
    const [articles, setArticles] = useState(articleData?.articles || [])
    const [page, setPage] = useState(articleData?.page || {})
    const [isLoading, setIsLoading] = useState(false)
    const cancelled = useRef(false)

    const getArticles = useCallback(
      async (currentPage = 1) => {
        if (!cancelled.current) {
          try {
            const response = await api.get(`/blog.json?page=${currentPage}`)

            setArticles([...articles, ...response.articles])
            setPage(response.page)
            setIsLoading(false)
          } catch (error) {
            console.log(error)
            setIsLoading(false)
          }
        }
      },
      [articles]
    )

    useEffect(() => {
      if (!articles.length) {
        setIsLoading(true)
        getArticles()
      }
    }, [getArticles])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <WrappedComponent
        articles={articles}
        getArticles={getArticles}
        isLoading={isLoading}
        page={page}
      />
    )
  }

  FetchArticles.propTypes = {
    articleData: PropTypes.object,
  }

  return FetchArticles
}
